const listOfArticles = [
  {
    id: 1,
    year: 2022,
    submenu: [
      {
        author:
          "Hosseini, Saleh, Amith Khandakar, Muhammad EH Chowdhury, Mohamed Arselene Ayari, Tawsifur Rahman, Moajjem Hossain Chowdhury, and Behzad Vaferi. ",
        title:
          "Novel and robust machine learning approach for estimating the fouling factor in heat exchangers.",
        details: "Energy Reports 8 (2022): 8767-8776.",
        doi: "https://doi.org/10.1016/j.egyr.2022.06.123",
      },
      {
        author:
          "Abir, Farhan Fuad, Khalid Alyafei, Muhammad EH Chowdhury, Amith Khandaker, Rashid Ahmed, Md Shafayet Hossain, Sakib Mahmud et al.",
        title:
          "PCovNet: A presymptomatic COVID-19 detection framework using deep learning model using wearables data.",
        details: "Computers in Biology and Medicine (2022): 105682.",
        doi: "https://doi.org/10.1016/j.compbiomed.2022.105682",
      },
      {
        author:
          "Khandakar, Amith, Muhammad EH Chowdhury, Mamun Bin Ibne Reaz, Sawal Hamid Md Ali, Serkan Kiranyaz, Tawsifur Rahman, Moajjem Hossain Chowdhury et al.",
        title:
          "A Novel Machine Learning Approach for Severity Classification of Diabetic Foot Complications Using Thermogram Images.",
        details: "Sensors 22, no. 11 (2022): 4249.",
        doi: "https://doi.org/10.3390/s22114249",
      },
      {
        author:
          "Gul, Sidra, Muhammad Salman Khan, Asima Bibi, Amith Khandakar, Mohamed Arselene Ayari, and Muhammad EH Chowdhury.",
        title:
          "Deep learning techniques for liver and liver tumor segmentation: A review.",
        details: "Computers in Biology and Medicine (2022): 105620.",
        doi: "https://doi.org/10.1016/j.compbiomed.2022.105620",
      },
      {
        author:
          "	Kashem, Saad Bin Abul, Akila Jayasinghe, Muhammad EH Chowdhury, Amith Khandakar, Azad Ashraf, A. Ansaruddin Kunju, Mohammad Nashbat et al. ",
        title:
          "A Review and Analysis of the Effects of Colors of Light On the Performance of Solar Photovoltaic Panels.",
        details:
          "International Journal of Integrated Engineering 14, no. 4 (2022): 116-136.",
        doi: "https://penerbit.uthm.edu.my/ojs/index.php/ijie/article/view/8162",
      },
      {
        author:
          "Tabassum, Mujahid, Sundresan Perumal, Saad Bin Abdul Kashem, Suresh Ponnan, Chinmay Chakraborty, Muhammad EH Chowdhury, and Amith Khandakar.",
        title:
          "Enhance data availability and network consistency using artificial neural network for IoT.",
        details: " Multimedia Tools and Applications (2022): 1-21.",
        doi: "https://doi.org/10.1007/s11042-022-13337-6",
      },
      {
        author:
          "Rahman, T., Khandakar, A., Islam, K. R., Soliman, M. M., Islam, M. T., Elsayed, A., ... & Chowdhury, M. E.",
        title:
          "HipXNet: Deep Learning Approaches to Detect Aseptic Loos-ening of Hip Implants using X-Ray Images.",
        details: " (2022). IEEE Access.",
        doi: "https://ieeexplore.ieee.org/document/9770775",
      },
      {
        author:
          "	Haque, F., Reaz, M.B.I., Chowdhury, M.E.H., Ezeddin, M., Kiranyaz, S., Alhatou, M., Ali, S.H.M., Bakar, A.A.A. and Srivastava, G., ",
        title:
          " Machine Learning-Based Diabetic Neuropathy and Previous Foot Ulceration Patients Detection Using Electromyography and Ground Reaction Forces during Gait. ",
        details: "2022.Sensors, 22(9), p.3507.",
        doi: "https://doi.org/10.3390/s22093507",
      },
      {
        author:
          "Subramanian, Nandhini, Omar Elharrouss, Somaya Al-Maadeed, and Muhammed Chowdhury.",
        title:
          "A review of deep learning-based detection methods for COVID-19.",
        details: "Computers in Biology and Medicine (2022): 105233.",
        doi: "https://doi.org/10.1016/j.compbiomed.2022.105233",
      },
      {
        author:
          "Rahman, T., Khandakar, A., Abir, F. F., Faisal, M. A. A., Hossain, M. S., Podder, K. K., ... & Chowdhury, M. E. (2022).",
        title:
          " QCovSML: A reliable COVID-19 detection system using CBC biomarkers by a stacking machine learning model.",
        details: "Computers in Biology and Medicine, 143, 105284.",
        doi: "https://doi.org/10.1016/j.compbiomed.2022.105284",
      },
      {
        author:
          "Haque, F., Reaz, M. B., Chowdhury, M. E., Kiranyaz, S., Ali, S. H., Alhatou, M., ... & Srivastava, G. (2022).",
        title:
          "Performance Analysis of Conventional Machine Learning Algorithms for Diabetic Sensorimotor Polyneuropathy Severity Classification Using Nerve Conduction Studies.",
        details: "Computational Intelligence and Neuroscience, 2022.",
        doi: "https://doi.org/10.1155/2022/9690940",
      },
      {
        author:
          "Cao, Y., H. A. Dhahad, A. Khandakar, M. E. H. Chowdury, M. A. Ayari, S. M. Alizadeh, and B. Vaferi.",
        title:
          "Employing computational fluid dynamics technique for analyzing the PACK-1300XY with methanol and isopropanol mixture.",
        details: "Scientific Reports 12, no. 1 (2022): 1-11.",
        doi: "https://doi.org/10.1038/s41598-022-10590-5",
      },
      {
        author:
          "Hossain, M.S., Chowdhury, M.E., Reaz, M.B.I., Ali, S.H.M., Bakar, A.A.A., Kiranyaz, S., Khandakar, A., Alhatou, M., Habib, R. and Hossain, M.M.",
        title:
          "Motion Artifacts Correction from Single-Channel EEG and fNIRS Signals Using Novel Wavelet Packet Decomposition in Combination with Canonical Correlation Analysis.",
        details: "2022. Sensors, 22(9), p.3169.",
        doi: "https://doi.org/10.3390/s22093169",
      },
      {
        author:
          "Rahman, T., Ibtehaz, N., Khandakar, A., Hossain, M. S. A., Mekki, Y. M. S., Ezeddin, M., ... & Chowdhury, M. E.",
        title:
          " QUCoughScope: An Intelligent Application to Detect COVID-19 Patients Using Cough and Breath Sounds.",
        details: "(2022). Diagnostics, 12(4), 920.",
        doi: "https://doi.org/10.3390/diagnostics12040920",
      },
      {
        author:
          "Gabbouj, M., Kiranyaz, S., Malik, J., Zahid, M. U., Ince, T., Chowdhury, M. E., ... & Tahir, A.",
        title:
          " Robust Peak Detection for Holter ECGs by Self-Organized Operational Neural Networks.",
        details:
          "(2022). IEEE Transactions on Neural Networks and Learning Systems.",
        doi: "https://ieeexplore.ieee.org/document/9743556",
      },
      {
        author:
          "Hossain, M. S., Reaz, M. B. I., Chowdhury, M. E., Ali, S. H., Bakar, A. A. A., Kiranyaz, S., ... & Habib, R.",
        title:
          " Motion Artifacts Correction from EEG and fNIRS Signals using Novel Multiresolution Analysis.",
        details: " (2022). IEEE Access, 10, 29760-29777.",
        doi: "https://ieeexplore.ieee.org/document/9733342",
      },
      {
        author:
          "Khandakar, A., Chowdhury, M. E., Reaz, M. B. I., Ali, S. H. M., Abbas, T. O., Alam, T., ... & Malik, R. A.",
        title:
          " Thermal change index-based diabetic foot thermogram image classification using machine learning techniques.",
        details: "(2022). Sensors, 22(5), 1793",
        doi: "https://doi.org/10.3390/s22051793",
      },
      {
        author: "Khandakar, A., Chowdhury, M. E., Khalid, M., & Zorba, N.",
        title:
          " Case Study of Multi-Course Project-Based Learning and Online Assessment in Electrical Engineering Courses during COVID-19 Pandemic.",
        details: "(2022). Sustainability, 14(9), 5056.",
        doi: "https://doi.org/10.3390/su14095056",
      },
      {
        author:
          "Rahman, Tawsifur, Alex Akinbi, Muhammad EH Chowdhury, Tarik A. Rashid, Abdulkadir Şengür, Amith Khandakar, Khandaker Reajul Islam, and Aras M. Ismael.",
        title:
          "COV-ECGNET: COVID-19 detection using ECG trace images with deep convolutional neural network.",
        details:
          " Health Information Science and Systems 10, no. 1 (2022): 1-16.",
        doi: "https://doi.org/10.1007/s13755-021-00169-1",
      },
      {
        author:
          "Nezhad, Erfan Zal, Masoud Sarraf, Farayi Musharavati, Fadi Jaber, J. I. Wang, Hamid Reza Madaah Hosseini, Sungchul Bae, Muhammad Chowdhury, Hongyun So, and Nazatul Liana Sukiman.",
        title:
          "Effect of zirconia nanotube coating on the hydrophilicity and mechanochemical behavior of zirconium for biomedical applications.",
        details: "Surfaces and Interfaces 28 (2022): 101623.",
        doi: "https://doi.org/10.1016/j.surfin.2021.101623",
      },
      {
        author:
          "Rahman, Arafat, Muhammad EH Chowdhury, Amith Khandakar, Anas M. Tahir, Nabil Ibtehaz, Md Shafayet Hossain, Serkan Kiranyaz, Junaid Malik, Haya Monawwar, and Muhammad Abdul Kadir.",
        title:
          "Robust biometric system using session invariant multimodal EEG and keystroke dynamics by the ensemble of self-ONNs.",
        details: "Computers in Biology and Medicine (2022): 105238",
        doi: "https://doi.org/10.1016/j.compbiomed.2022.105238",
      },
      {
        author:
          "	Tahir, Anas M., Yazan Qiblawey, Amith Khandakar, Tawsifur Rahman, Uzair Khurshid, Farayi Musharavati, M. T. Islam, Serkan Kiranyaz, Somaya Al-Maadeed, and Muhammad EH Chowdhury.",
        title:
          "Deep learning for reliable classification of COVID-19, MERS, and SARS from chest X-ray images.",
        details: "Cognitive Computation (2022): 1-21.",
        doi: "https://doi.org/10.1007/s12559-021-09955-1",
      },
      {
        author:
          "Faisal, Ahasan Atick, Muhammad EH Chowdhury, Amith Khandakar, Shafayet Hossain, Mohammed Alhatou, Sakib Mahmud, Iffat Ara, Shah Imran Sheikh, and Mosabber Uddin Ahmed.",
        title:
          "An investigation to study the effects of Tai Chi on human gait dynamics using classical machine learning.",
        details: "Computers in biology and medicine (2022): 105184",
        doi: "https://doi.org/10.1016/j.compbiomed.2021.105184",
      },
      {
        author:
          "	Wang, Jing, Mohamed Arselene Ayari, Amith Khandakar, Muhammad EH Chowdhury, S. M. Uz Zaman, Tawsifur Rahman, and Behzad Vaferi.",
        title:
          "Estimating the Relative Crystallinity of Biodegradable Polylactic Acid and Polyglycolide Polymer Composites by Machine Learning Methodologies.",
        details: "Polymers 14, no. 3 (2022): 527.",
        doi: "https://doi.org/10.3390/polym14030527",
      },
      {
        author:
          "Podder, Kanchon Kanti, Muhammad EH Chowdhury, Anas M. Tahir, Zaid Bin Mahbub, Amith Khandakar, Md Shafayet Hossain, and Muhammad Abdul Kadir.",
        title:
          "Bangla Sign Language (BdSL) Alphabets and Numerals Classification Using a Deep Learning Model.",
        details: "Sensors 22, no. 2 (2022): 574.",
        doi: "https://doi.org/10.3390/s22020574",
      },
      {
        author:
          "	Mahmud, Sakib, Nabil Ibtehaz, Amith Khandakar, Anas M. Tahir, Tawsifur Rahman, Khandaker Reajul Islam, Md Shafayet Hossain et al.",
        title:
          "A Shallow U-Net Architecture for Reliably Predicting Blood Pressure (BP) from Photoplethysmogram (PPG) and Electrocardiogram (ECG) Signals.",
        details: "Sensors 22, no. 3 (2022): 919.",
        doi: "https://doi.org/10.3390/s22030919",
      },
      {
        author:
          "	Hossain, M. I., A. Khandakar, M. E. H. Chowdhury, S. Ahmed, M. M. Nauman, and B. Aïssa.",
        title:
          "Numerical and Experimental Investigation of Infrared Optical Filter Based on Metal Oxide Thin Films for Temperature Mitigation in Photovoltaics.",
        details: " Journal of Electronic Materials 51, no. 1 (2022): 179-189.",
        doi: "https://doi.org/10.1007/s11664-021-09269-w",
      },
    ],
  },
  {
    id: 2,
    year: 2021,
    submenu: [
      {
        author:
          "Ibtehaz, Nabil, Muhammad EH Chowdhury, Amith Khandakar, Serkan Kiranyaz, M. Sohel Rahman, Anas Tahir, Yazan Qiblawey, and Tawsifur Rahman.",
        title:
          "EDITH: ECG biometrics aided by Deep learning for reliable Individual auTHentication.",
        details:
          " IEEE Transactions on Emerging Topics in Computational Intelligence (2021).",
        doi: "https://ieeexplore.ieee.org/document/9655256",
      },
      {
        author:
          "Haque, Fahmida, Mamun Bin Ibne Reaz, Muhammad EH Chowdhury, Sawal Hamid Md Ali, Ahmad Ashrif A. Bakar, Tawsifur Rahman, Syoji Kobashi, Chitra A. Dhawale, and Mohammad Arif Sobhan Bhuiyan.",
        title:
          "A nomogram-based diabetic sensorimotor polyneuropathy severity prediction using Michigan neuropathy screening instrumentations.",
        details: "Computers in Biology and Medicine 139 (2021): 104954.",
        doi: "https://doi.org/10.1016/j.compbiomed.2021.104954",
      },
      {
        author:
          "Tahir, Anas M., Muhammad EH Chowdhury, Amith Khandakar, Tawsifur Rahman, Yazan Qiblawey, Uzair Khurshid, Serkan Kiranyaz et al.",
        title:
          "COVID-19 infection localization and severity grading from chest X-ray images.",
        details: " Computers in biology and medicine 139 (2021): 105002.",
        doi: "https://doi.org/10.1016/j.compbiomed.2021.105002",
      },
      {
        author:
          "Khandakar, Amith, Muhammad EH Chowdhury, Mamun Bin Ibne Reaz, Sawal Hamid Md Ali, Md Anwarul Hasan, Serkan Kiranyaz, Tawsifur Rahman, Rashad Alfkey, Ahmad Ashrif A. Bakar, and Rayaz A. Malik.",
        title:
          "A machine learning model for early detection of diabetic foot using thermogram images.",
        details: " Computers in Biology and Medicine 137 (2021): 104838.",
        doi: "https://doi.org/10.1016/j.compbiomed.2021.104838",
      },
      {
        author:
          "Zaman, Kh Shahriya, Mamun Bin Ibne Reaz, Sawal Hamid Md Ali, Ahmad Ashrif A. Bakar, and Muhammad Enamul Hoque Chowdhury.",
        title:
          "Custom Hardware Architectures for Deep Learning on Portable Devices: A Review.",
        details:
          "IEEE Transactions on Neural Networks and Learning Systems (2021).",
        doi: "https://ieeexplore.ieee.org/document/9447019",
      },
      {
        author:
          "Rahman, T., Khandakar, A., Hoque, M. E., Ibtehaz, N., Kashem, S. B., Masud, R., ... & Chowdhury, M. E. (2021).",
        title:
          "Development and Validation of an Early Scoring System for Prediction of Disease Severity in COVID-19 using Complete Blood Count Parameters",
        details: "IEEE Access, vol-9, pp120422 - 120441.",
        doi: "https://ieeexplore.ieee.org/document/9514609",
      },
      {
        author:
          "Rahman, T.; Al-Ishaq, F.A.; Al-Mohannadi, F.S.; Mubarak, R.S.; Al-Hitmi, M.H.; Islam, K.R.; Khandakar, A.; Hssain, A.A.; Al-Madeed, S.; Zughaier, S.M.; Chowdhury, M.E.H.",
        title:
          "Mortality Prediction Utilizing Blood Biomarkers to Predict the Severity of COVID-19 Using Machine Learning Technique",
        details: " Diagnostics 2021, 11, 1582.",
        doi: "https://doi.org/10.3390/diagnostics11091582",
      },
      {
        author:
          "Shuzan, Md Nazmul Islam, Moajjem Hossain Chowdhury, Md Shafayet Hossain, Muhammad EH Chowdhury, Mamun Bin Ibne Reaz, M. Monir Uddin, Amith Khandakar, Zaid B. Mahbub, and Sawal Hamid Md Ali.",
        title:
          "A Novel Non-Invasive Estimation of Respiration Rate from Motion Corrupted Photoplethysmograph Signal Using Machine Learning Model.",
        details: " IEEE Access (2021), vol-9, pp96775 - 96790. (Q1)",
        doi: "https://ieeexplore.ieee.org/document/9475991",
      },
      {
        author:
          "Rahman, Arafat, Muhammad EH Chowdhury, Amith Khandakar, Serkan Kiranyaz, Kh Shahriya Zaman, Mamun Bin Ibne Reaz, Mohammad Tariqul Islam, Maymouna Ezeddin, and Muhammad Abdul Kadir.",
        title:
          "Multimodal EEG and Keystroke Dynamics Based Biometric System Using Machine Learning Algorithms.",
        details: " IEEE Access (2021), v-9, pp94625 - 94643. (Q1)",
        doi: "10.1109/ACCESS.2021.3092840",
      },
      {
        author:
          "Hannan, Saif, Mohammad Tariqul Islam, Mohammad Rashed Iqbal Faruque, Muhammad EH Chowdhury, and Farayi Musharavati.",
        title:
          "Angle-insensitive co-polarized metamaterial absorber based on equivalent circuit analysis for dual band WiFi applications.",
        details: "Scientific reports 11, no. 1 (2021): 1-13. (Q1)",
        doi: "https://doi.org/10.1038/s41598-021-93322-5",
      },
      {
        author:
          "Md. Moniruzzaman, Mohammad Tariqul Islam, Norbahiah Misran, Md Samsuzzaman, Touhidul Alam, Muhammad E.H. Chowdhury",
        title:
          "Inductively Tuned Modified Split Ring Resonator based Quad Band Epsilon Negative(ENG) with Near Zero Index (NZI) Metamaterial for Multiband Antenna Performance Enhancement",
        details: "Scientific Reports 11, pp 1-29 (2021)  (Q1)",
        doi: "https://doi.org/10.1038/s41598-021-91432-8",
      },
      {
        author:
          "Hossain, Amran, Mohammad Tariqul Islam, Mohammad Shahidul Islam, Muhammad EH Chowdhury, Ali F. Almutairi, Qutaiba A. Razouqi, and Norbahiah Misran.",
        title:
          "A YOLOv3 Deep Neural Network Model to Detect Brain Tumor in Portable Electromagnetic Imaging System.",
        details: "IEEE Access (2021), v-9, pp 82647 - 82660. (Q1)",
        doi: "https://ieeexplore.ieee.org/document/9446998",
      },
      {
        author:
          "Rahman, M. A., Islam, M. T., Singh, M. S. J., Chowdhury, M. E., & Samsuzzaman, M. (2021).",
        title:
          "Quad-band flexible magnesium zinc ferrite (MgZnFe2O4)-based double negative metamaterial for microwave applications.",
        details: "Chinese Journal of Physics, 71, 351-364. (Q1)",
        doi: "https://doi.org/10.1016/j.cjph.2021.02.014",
      },
      {
        author:
          "Md Atiqur Rahman, Mohammad Tariqul Islam, Mandeep Singh Jit Singh, Md Samsuzzaman, Muhammad E. H. Chowdhury.",
        title:
          "Synthesis and characterization of Mg-Zn ferrite based flexible microwave composites and its application as SNG metamaterial",
        details: "  Scientific Reports, 11, 7654 (2021). (Q1)",
        doi: "https://doi.org/10.1038/s41598-021-87100-6 ",
      },
      {
        author:
          "Degerli, Aysen, Mete Ahishali, Mehmet Yamac, Serkan Kiranyaz, Muhammad EH Chowdhury, Khalid Hameed, Tahir Hamid, Rashid Mazhar, and Moncef Gabbouj.",
        title:
          "COVID-19 infection map generation and detection from chest X-ray images.",
        details:
          " Health Information Science and Systems 9, no. 1 (2021): 1-16. (Q1)",
        doi: "https://doi.org/10.1007/s13755-021-00146-8",
      },
      {
        author:
          "Chowdhury, Muhammad EH, Tawsifur Rahman, Amith Khandakar, Mohamed Arselene Ayari, Aftab Ullah Khan, Muhammad Salman Khan, Nasser Al-Emadi, Mamun Bin Ibne Reaz, Mohammad Tariqul Islam, and Sawal Hamid Md Ali.",
        title:
          "Automatic and Reliable Leaf Disease Detection Using Deep Learning Techniques.",
        details: " AgriEngineering 3, no. 2 (2021): 294-312. (Q3)",
        doi: "https://doi.org/10.3390/agriengineering3020020",
      },
      {
        author:
          "Soliman, Md Mohiuddin, Muhammad EH Chowdhury, Amith Khandakar, Mohammad Tariqul Islam, Yazan Qiblawey, Farayi Musharavati, and Erfan Zal Nezhad.",
        title:
          "Review on Medical Implantable Antenna Technology and Imminent Research Challenges.",
        details: "Sensors 21, no. 9 (2021): 3163. (Q1)",
        doi: "https://doi.org/10.3390/s21093163",
      },
      {
        author:
          "Qiblawey, Yazan, Anas Tahir, Muhammad EH Chowdhury, Amith Khandakar, Serkan Kiranyaz, Tawsifur Rahman, Nabil Ibtehaz et al.",
        title:
          "Detection and severity classification of COVID-19 in CT images using deep learning.",
        details: "Diagnostics 11, no. 5 (2021): 893. (Q1)",
        doi: "https://doi.org/10.3390/diagnostics11050893",
      },
      {
        author:
          "Haque, Fahmida, Mamun Bin Ibne Reaz, Muhammad Enamul Hoque Chowdhury, Geetika Srivastava, Sawal Hamid Md Ali, Ahmad Ashrif A. Bakar, and Mohammad Arif Sobhan Bhuiyan.",
        title:
          "Performance Analysis of Conventional Machine Learning Algorithms for Diabetic Sensorimotor Polyneuropathy Severity Classification.",
        details: "Diagnostics 11, no. 5 (2021): 801. (Q1)",
        doi: "https://doi.org/10.3390/diagnostics11050801",
      },
      {
        author:
          "Hoque, Ahasanul, Mohammad Tariqul Islam, Ali F. Almutairi, and Muhammad EH Chowdhury.",
        title:
          "DNG Metamaterial reflector using SOCT shaped resonator for Microwave Applications.",
        details: "IEEE Access (2021). (Q1)",
        doi: "https://ieeexplore.ieee.org/document/9395577",
      },
      {
        author:
          "Islam, Mohammad Shahidul, Mohammad Tariqul Islam, Ahasanul Hoque, Md Tarikul Islam, Nowshad Amin, and Muhammad EH Chowdhury.",
        title:
          "A Portable Electromagnetic Head Imaging System Using Metamaterial Loaded Compact Directional 3D Antenna.",
        details: "IEEE Access, v 8(2021), pp50893-50906. (Q1)",
        doi: "https://ieeexplore.ieee.org/document/9389733",
      },
      {
        author:
          "Rahman, T., Khandakar, A., Qiblawey, Y., Tahir, A., Kiranyaz, S., Kashem, S.B.A., Islam, M.T., Maadeed, S.A., Zughaier, S.M., Khan, M.S. and Chowdhury, M.E.",
        title:
          "Exploring the Effect of Image Enhancement Techniques on COVID-19 Detection using Chest X-rays Images.",
        details:
          "Computer in Medicine and Biology, Volume 132, May 2021, 104319. (Q2)",
        doi: "https://doi.org/10.1016/j.compbiomed.2021.104319",
      },
      {
        author:
          "Nada Abughanam, Shahd Sameer Mohammed Gaben, Muhammad E.H. Chowdhury, Amith Khandakar.",
        title:
          "Investigating the Effect of Materials and Structures for Negative Pressure Ventilators Suitable for Pandemic Situation",
        details: " Emergent Materials (2021).(Q3)",
        doi: "https://doi.org/10.1007/s42247-021-00181-x",
      },
      {
        author:
          "Ahishali, Mete, Aysen Degerli, Mehmet Yamac, Serkan Kiranyaz, Muhammad EH Chowdhury, Khalid Hameed, Tahir Hamid, Rashid Mazhar, and Moncef Gabbouj.",
        title:
          "Advance warning methodologies for covid-19 using chest x-ray images.",
        details: "IEEE Access 9 (2021): 41052-41065. (Q1)",
        doi: "https://ieeexplore.ieee.org/document/9373311",
      },
      {
        author:
          "Yamaç, Mehmet, Mete Ahishali, Aysen Degerli, Serkan Kiranyaz, Muhammad EH Chowdhury, and Moncef Gabbouj.",
        title:
          "Convolutional Sparse Support Estimator-Based COVID-19 Recognition From X-Ray Images.",
        details:
          " IEEE Transactions on Neural Networks and Learning Systems (2021), v-32, pp1810 - 1820. (Q1)",
        doi: "https://ieeexplore.ieee.org/document/9408240",
      },
      {
        author:
          "Rahman, Md Atiqur, Mohammad Tariqul Islam, Mandeep Singh Jit Singh, Muhammad EH Chowdhury, and Md Samsuzzaman.",
        title:
          "Quad-band flexible magnesium zinc ferrite (MgZnFe2O4)-based double negative metamaterial for microwave applications.",
        details:
          "Chinese Journal of Physics, Volume 71, June 2021, Pages 351-364. (Q1)",
        doi: "https://doi.org/10.1016/j.cjph.2021.02.014",
      },
      {
        author:
          "Chowdhury, Muhammad EH, Tawsifur Rahman, Amith Khandakar, Somaya Al-Madeed, Susu M. Zughaier, Suhail AR Doi, Hanadi Hassen, and Mohammad T. Islam.",
        title:
          "An early warning tool for predicting mortality risk of COVID-19 patients using machine learning.",
        details: " Cognitive Computation (2021): 1-16. (Q1)",
        doi: "https://doi.org/10.1007/s12559-020-09812-7",
      },
      {
        author:
          "[Accepted] Muhammad E. H. Chowdhury, Amith Khandakar, Khawla Alzoubi, Anas Tahir, Aisha Mohammed, Safaa Taha, Aya Omar, Mamun Bin Ibne Reaz. ",
        title:
          "Wearable Real-time Epileptic Seizure Detection and Warning System",
        details: "Computer in Medicine and Biology, 2020. (Q2)",
        doi: "https://doi.org/10.1007/978-3-030-97845-7_11",
      },
      {
        author:
          "Fahmida Hoque, Mamun Bin Ibne Reaz, Muhammad E. H. Chowdhury, Sawal Ali.",
        title:
          "Diabetic Sensorimotor Polyneuropathy Severity Classification Using Adaptive Neuro Fuzzy Inference System",
        details: " in IEEE Access, 2020, Vol. 8, pp7618 - 7631. (Q1)",
        doi: "https://ieeexplore.ieee.org/document/9312145",
      },
      {
        author:
          "Yazan Qiblawey, Muhammad E.H. Chowdhury, Farayi Musharavati, Erfan Zalnezhad, Amith Khandakar, Mohammad Tariqul Islam.",
        title: "Instrumented Hip Implant: A Review",
        details:
          " IEEE Sensors, Volume: 21, Issue: 6, pp. 7179 - 7194, March15, 2021. (Q1)",
        doi: "https://ieeexplore.ieee.org/document/9296249",
      },
      {
        author:
          "Md Tarikul Islam, Mohammad Tariqul Islam, Md Samsuzzaman, Salehin Kibria, Muhammad E. H. Chowdhury.",
        title:
          "Microwave Breast Imaging using Compressed Sensing Approach of Iteratively Corrected Delay Multiply and Sum Beamformer",
        details: "Diagnostics 2021, 11(3), 470 (Q1)",
        doi: "https://doi.org/10.3390/diagnostics11030470",
      },
      {
        author:
          "Zalnezhad, Erfan, F. Musharavati, Tianyi Chen, Fadi Jaber, Kaan Uzun, Muhammad EH Chowdhury, Amith Khandakar, Junxing Liu, and S. Bae.",
        title:
          "Tribo-mechanical properties evaluation of HA/TiO 2/CNT nanocomposite.",
        details: " Nature Scientific reports 11, no. 1 (2021): 1-15. (Q1)",
        doi: "https://doi.org/10.1038/s41598-021-81187-7",
      },
      {
        author:
          "Nezhad, Erfan Zal, Xiang Qu, Farayi Musharavati, Fadi Jaber, Mark R. Appleford, S. Bae, Kaan Uzun, Morgan Struthers, Muhammad EH Chowdhury, and Amith Khandakar. ",
        title:
          "Effects of titanium and carbon nanotubes on nano/micromechanical properties of HA/TNT/CNT nanocomposites.",
        details: "Applied Surface Science 538: 148123, 2021. (Q1)",
        doi: "https://doi.org/10.1016/j.apsusc.2020.148123",
      },
      {
        author:
          "Qiblawey, Yazan, Muhammad EH Chowdhury, Farayi Musharavati, Erfan Zalnezhad, Amith Khandakar, and Mohammad Tariqul Islam.",
        title: "Instrumented Hip Implant: A Review.",
        details: "IEEE Sensors Journal (2020). (Q1)",
        doi: "https://ieeexplore.ieee.org/document/9296249",
      },
    ],
  },
  {
    id: 3,
    year: 2020,
    submenu: [
      {
        author:
          "Haque, Fahmida, Mamun Bin Ibne Reaz, Sawal Hamid Md Ali, Norhana Arsad, and Muhammad Enamul Hoque Chowdhury.",
        title:
          "Performance analysis of noninvasive electrophysiological methods for the assessment of diabetic sensorimotor polyneuropathy in clinical research: a systematic review and meta-analysis with trial sequential analysis.",
        details: "Scientific Reports 10, no. 1 (2020): 21770-21770. (Q1)",
        doi: "https://doi.org/10.1038/s41598-020-78787-0",
      },
      {
        author:
          "Hossain, Amran, Mohammad Tariqul Islam, Muhammad EH Chowdhury, and Md Samsuzzaman.",
        title:
          "A Grounded Coplanar Waveguide-Based Slotted Inverted Delta-Shaped Wideband Antenna for Microwave Head Imaging.",
        details:
          "IEEE Access 8 (2020): 185698-185724. (IF-3.745, Q1, Scopus Indexed).",
        doi: "https://ieeexplore.ieee.org/document/9217502",
      },
      {
        author:
          "Jamal, Mohammad H., Suhail A. Doi, Sarah AlYouha, Sulaiman Almazeedi, Mohannad Al-Haddad, Ali Al-Muhaini, Fahad Al-Ghimlas, Muhammad E. Chowdhury, and Salman Al-Sabah.",
        title:
          "A biomarker based severity progression indicator for COVID-19: the Kuwait prognosis indicator score.",
        details: " Biomarkers (2020): 1-8. (Q2, Scopus Indexed). ",
        doi: "https://doi.org/10.1080/1354750X.2020.1841296",
      },
      {
        author: "CL Ng, MI Reaz, ML Crespo, A Cicuttin, MEH Chowdhury. ",
        title:
          "Characterization of capacitive electromyography biomedical sensor insulated with porous medical bandages",
        details:
          "Scientific Reports (nature), 10, 2020. (IF-4.120, Q1, Scopus Indexed).",
        doi: "https://doi.org/10.1038/s41598-020-71709-0",
      },
      {
        author:
          "Muhammad E.H. Chowdhury, Amith Khandakar, Saba Ahmed, Fatima Al-Khuzaei, Jalaa Hamdalla, Fahmida Haque, Mamun Bin Ibne Reaz, Ahmed Al Shafei, Nasser Al-Emadi.",
        title:
          "Design, Construction and Testing of IoT based Automated Indoor Vertical Hydroponics Farming Test-bed in Qatar",
        details: " in Sensors 2020, 20(19), 5637;(Q1)",
        doi: "https://doi.org/10.3390/s20195637.",
      },
      {
        author:
          "Rahman, Tawsifur, Amith Khandakar, Muhammad Abdul Kadir, Khandaker Rejaul Islam, Khandakar F. Islam, Rashid Mazhar, Tahir Hamid, Muhammad E.H. Chowdhury.",
        title:
          "Reliable tuberculosis detection using chest X-ray with deep learning, segmentation and visualization.",
        details:
          "IEEE Access 8 (2020): 191586-191601. (IF-3.745, Q1, Scopus Indexed).",
        doi: "https://ieeexplore.ieee.org/document/9224622",
      },
      {
        author:
          "Mahmud, Sultan, Sikder Sunbeam Islam, Kamarulzaman Mat, Muhammad E.H. Chowdhury, Hatem Rmili, and Mohammad Tariqul Islam.",
        title:
          "Design and parametric analysis of a wide-angle polarization-insensitive metamaterial absorber with a star shape resonator for optical wavelength applications.",
        details:
          "Results in Physics (2020): 103259. (IF- 4.019, Q1, Scopus Indexed).",
        doi: "https://doi.org/10.1016/j.rinp.2020.103259",
      },
      {
        author:
          "Islam, Mohammad Shahidul, Mohammad Tariqul Islam, Norsuzlin Mohd Sahar, Hatem Rmili, Nowshad Amin, and Muhammad E.H. Chowdhury.",
        title:
          "A Mutual Coupled Concentric Crossed-Line Split Ring Resonator (CCSRR) Based Epsilon Negative (ENG) Metamaterial for Tri-band Microwave Applications.",
        details:
          "Results in Physics (2020): 103292. (IF- 4.019, Q1, Scopus Indexed).",
        doi: "https://doi.org/10.1016/j.rinp.2020.103292",
      },
      {
        author:
          "Moniruzzaman, Md, Mohammad Tariqul Islam, Md Tarikul Islam, Muhammad E.H. Chowdhury, Hatem Rmili, and Md Samsuzzaman.",
        title:
          "Cross Coupled Interlinked Split Ring Resonator Based Epsilon Negative Metamaterial with High Effective Medium Ratio for Multiband Satellite and Radar Communications.",
        details:
          " Results in Physics (2020): 103296. (IF- 4.019, Q1, Scopus Indexed). ",
        doi: "https://doi.org/10.1016/j.rinp.2020.103296",
      },
      {
        author:
          "Hoque, Ahasanul, Mohammad Tariqul Islam, Ali F. Almutairi, Muhammad E.H. Chowdhury, and Md Samsuzzaman.",
        title:
          "SNG and DNG meta-absorber with fractional absorption band for sensing application.",
        details:
          "Scientific Reports (Nature) 10, no. 1 (2020): 1-17. (IF-4.120, Q1, Scopus Indexed). ",
        doi: "https://doi.org/10.1038/s41598-020-69792-4",
      },
      {
        author:
          "Hussain, Arif, Anwarul Hasan, Mohammad Mahdi Nejadi Babadaei, Samir Haj Bloukh, Muhammad E.H. Chowdhury, Majid Sharifi, Setareh Haghighat, and Mojtaba Falahati.",
        title:
          "Targeting SARS-CoV2 Spike Protein Receptor Binding Domain by Therapeutic Antibodies.",
        details:
          " Biomedicine & Pharmacotherapy (2020): 110559. ((IF-4.545, Q1, Scopus Indexed).",
        doi: "https://doi.org/10.1016/j.biopha.2020.110559",
      },
      {
        author:
          "Hannan, Saif, Mohammad Tariqul Islam, Norsuzlin Mohd Sahar, Kamarulzaman Mat, Muhammad E.H. Chowdhury, and Hatem Rmili.",
        title:
          "Modified-Segmented Split-Ring Based Polarization and Angle-Insensitive Multi-Band Metamaterial Absorber for X, Ku and K Band Applications.",
        details:
          " IEEE Access (2020), 8, pp 44051 - 144063. (IF-3.745, Q1, Scopus Indexed). ",
        doi: "https://ieeexplore.ieee.org/document/9152819",
      },
      {
        author:
          "Teoh Ji Sheng, Mohammad Shahidul Islam, Norbahiah Misran, Mohd Hafiz Baharuddin, Haslina Arshad, Md. Rashedul Islam, Muhammad E. H. Chowdhury, Hatem Rmili, Mohammad Tariqul Islam",
        title:
          "An Internet of Things Based Smart Waste Management System Using LoRa and Tensorflow Deep Learning Model,",
        details:
          "IEEE Access, vol. 8, pp. 148793-148811, 2020,(IF-3.745, Q1, Scopus Indexed)",
        doi: "https://ieeexplore.ieee.org/document/9165744",
      },
      {
        author:
          "Amran Hossain, Mohammad Tariqul Islam, Md Tarikul Islam, Muhammad E. H. Chowdhury, Hatem Rmili, Md. Samsuzzaman",
        title:
          "A Planar Ultra wideband Patch Antenna Array for Microwave Breast Tumour Detection",
        details: "Materials 2020 Nov 2;13(21):4918. (Q1, Scopus Indexed).",
        doi: "https://doi.org/10.3390/ma13214918",
      },
      {
        author:
          "Dahmani, M.; Chowdhury, M.E.H.; Khandakar, A.; Rahman, T.; Al-Jayyousi, K.; Hefny, A.; Kiranyaz. ",
        title:
          "An Intelligent and Low-Cost Eye-Tracking System for Motorized Wheelchair Control.",
        details: "S. Sensors 2020, 20, 3936. (IF-3.275, Q1, Scopus Indexed). ",
        doi: " https://doi.org/10.3390/s20143936",
      },
      {
        author:
          "Nan, JiFeng, Mohammadreza Rezaei, Rashid Mazhar, Fadi Jaber, Farayi Musharavati, Erfan Zalnezhad, and Muhammad E.H. Chowdhury. ",
        title:
          "Finite Element Analysis of the Mechanism of Traumatic Aortic Rupture (TAR).",
        details:
          "Computational and mathematical methods in medicine, v 2020 (2020). (IF- 1.770, Q2, Scopus Indexed). ",
        doi: " https://doi.org/10.1155/2020/6718495",
      },
      {
        author:
          "Rahman, Tawsifur, Muhammad E.H. Chowdhury, Amith Khandakar, Khandaker R. Islam, Khandaker F. Islam, Zaid B. Mahbub, Muhammad A. Kadir, and Saad Kashem.",
        title:
          "Transfer Learning with Deep Convolutional Neural Network (CNN) for Pneumonia Detection using Chest X-ray.",
        details:
          "Applied Sciences 10, no. 9 (2020): 3233. (IF- 2.474, Q1, Scopus Indexed). ",
        doi: "https://doi.org/10.3390/app10093233",
      },
      {
        author:
          "Khandakar, Amith, Annaufal Rizqullah, Anas Ashraf Abdou Berbar, Mohammad Rafi Ahmed, Atif Iqbal, Muhammad E.H. Chowdhury, and S. M. Uz Zaman.",
        title:
          "A Case Study to Identify the Hindrances to Widespread Adoption of Electric Vehicles in Qatar.",
        details:
          "Energies 13, no. 15 (2020): 3994. (IF- 2.474, Q2, Scopus Indexed). ",
        doi: "https://doi.org/10.3390/en13153994",
      },
      {
        author:
          "Chowdhury, Moajjem Hossain, Md Nazmul Islam Shuzan, Muhammad E.H. Chowdhury, Zaid B. Mahbub, M. Monir Uddin, Amith Khandakar, and Mamun Bin Ibne Reaz.",
        title:
          "Estimating Blood Pressure from the Photoplethysmogram Signal and Demographic Features Using Machine Learning Techniques.",
        details:
          "Sensors 20, no. 11 (2020): 3127. (IF-3.275, Q1, Scopus Indexed). ",
        doi: "https://doi.org/10.3390/s20113127",
      },
      {
        author:
          "Folla Kamdem Jérôme, Wembe Tafo Evariste, Essimbi Zobo Bernard, Maria Liz Crespo, Andres Cicuttin, Mamun Bin Ibne Reaz, Mohammad Arif Sobhan Bhuiyan, Muhammad Enamul Hoque Chowdhury. ",
        title:
          "A 0.35 µm Low-Noise Stable Charge Sensitive Amplifier for Silicon Detectors Applications.",
        details:
          "Informacije MIDEM 50, no. 1 (2020): 3-14. (Q4, Scopus Indexed).",
        doi: "https://doi.org/10.33180/InfMIDEM2020.101",
      },
      {
        author:
          "Chowdhury, Muhammad EH, Tawsifur Rahman, Amith Khandakar, Rashid Mazhar, Muhammad Abdul Kadir, Zaid Bin Mahbub, Khandaker Reajul Islam et al.",
        title: "Can AI help in screening viral and COVID-19 pneumonia?.",
        details:
          "in IEEE Access, 2020 vol. 8, pp 132665 - 132676. (IF-3.745, Q1, Scopus Indexed).",
        doi: "https://ieeexplore.ieee.org/document/9144185",
      },
      {
        author:
          "Anas M Tahir, Muhammad E.H. Chowdhury, Amith Khandakar, Sara Al-Hamouz, Merna Abdalla, Sara Awadalla, Mamun Bin Ibne Reaz, Nasser Al-Emadi. ",
        title:
          "A Systematic Approach for Design and Characterization of Low-Cost Smart Insole for Detecting Vertical Ground Reaction Force (vGRF) in Gait Analysis",
        details: "Sensors, 2020, 20(4), 957. (IF-3.275, Q1, Scopus Indexed).",
        doi: "https://doi.org/10.3390/s20040957",
      },
      {
        author:
          "Amith Khandakar, Muhammad E. H. Chowdhury, Antonio Jr. San Pedro Gonzales, Farid Touati, Mohamed Arselene Ayari, Nasser Al Emadi,",
        title:
          "Case Study to Analyze the Impact of Multi-Course Project-Based Learning Approach on Education for Sustainable Development",
        details:
          "Sustainability, 12(2), 480, 2020. (IF-2.576, Q2, Scopus Indexed).",
        doi: " https://doi.org/10.3390/su12020480",
      },
    ],
  },
  {
    id: 4,
    year: 2019,
    submenu: [
      {
        author:
          "Ng, Charn Loong, Mamun Bin Ibne Reaz, and Muhammad Enamul Hoque Chowdhury.",
        title:
          "A Low Noise Capacitive Electromyography Monitoring System for Remote Healthcare Applications.",
        details:
          "IEEE Sensors Journal 20, no. 6 (2019): 3333-3342. (IF-3.076, Q1, Scopus Indexed).",
        doi: "https://ieeexplore.ieee.org/document/8918279",
      },
      {
        author:
          "Muhammad E.H. Chowdhury, Khawla Alzoubi, Amith Khandakar, Ridab Khalifa, Rayaan Abou hashera, Sirine Koubaa, Rashid Ahmed, Anwarul Hasan,",
        title:
          "Wearable Real Time Heart Attack Detection and Warning System to Reduce Road Accidents.",
        details: "Sensors, 19(12), 2780, 2019. (IF-3.031, Q1, Scopus Indexed)",
        doi: "https://doi.org/10.3390/s19122780",
      },
      {
        author:
          "Amith Khandakar, Muhammad E. H. Chowdhury, Monzure Khoda Kazi, Kamel Benhmed, Farid Touati, Mohammed Al-Hitmi, Jr SP Gonzales, ",
        title:
          "Machine learning based photovoltaics (PV) power prediction using different environmental parameters of Qatar",
        details: "Energies, 12(14), 2782, 2019. (IF-2.676, Q2, Scopus Indexed)",
        doi: "https://doi.org/10.3390/en12142782",
      },
      {
        author:
          "Muhammad E.H. Chowdhury, Amith Khandakar, Khawla Alzoubi, Samar Mansoor, Anas Tahir, Mamun Bin Ibne Reaz, Nasser Al-Emadi. ",
        title:
          "Real-Time Smart-Digital Stethoscope System for Heart Diseases Monitoring",
        details: "Sensors, 19(12), 2781, 2019. (IF-3.031, Q1, Scopus Indexed)",
        doi: " https://doi.org/10.3390/s19122781",
      },
      {
        author:
          "Muhammad E. H. Chowdhury, Amith Khandakar, Belayat Hossain, Karen J. Mullinger, Nasser Al-Emadi, Andre Antunes, Richard W. Bowtell, ",
        title:
          "Reference Layer Artefact Subtraction: electromagnetic simulations",
        details:
          "IEEE Access, 7, 17882-17895, 2019. (IF-4.098, Q1, Scopus Indexed).",
        doi: "https://ieeexplore.ieee.org/document/8611330",
      },
      {
        author:
          "Amith Khandakar, Muhammad E.H. Chowdhury, Rashid Ahmed, Ahmed Dhib, Mohammed Mohammed, Nasser Ahmed Al-Emadi, Dave Michelson,",
        title:
          "Portable system for monitoring and controlling driver behaviour and the use of a mobile phone while driving.",
        details: "Sensors, 19(7), 1563, 2019. (IF-3.031, Q1, Scopus Indexed) ",
        doi: "https://doi.org/10.3390/s19071563",
      },
      {
        author:
          "Muhammad E. H. Chowdhury, Md. Belayat Hossain, Rayaan Abouhasera, Amith Khandaker,",
        title:
          "A Low-Cost Closed-Loop Solar Tracking System Based on the Sun Position Algorithm",
        details: "Journal of Sensors, 2019. (IF-2.057, Q2, Scopus Indexed)",
        doi: "https://doi.org/10.1155/2019/3681031",
      },
      {
        author:
          "Muhammad E. H. Chowdhury, Amith Khandakar, Karen J. Mullinger, Nasser Al-Emadi, Richard Bowtell, ",
        title:
          "Simultaneous EEG-fMRI: evaluating the effect of the EEG cap cabling configuration on the gradient artefact.",
        details:
          "Frontiers in Neuroscience, section Brain Imaging Methods, 2019. (IF- 3.398, Q1, Scopus Indexed).",
        doi: "https://doi.org/10.3389/fnins.2019.00690",
      },
    ],
  },
  {
    id: 5,
    year: 2018,
    submenu: [
      {
        author:
          "Glyn S. Spencer, James A. Smith, Muhammad E. H. Chowdhury, Richard W. Bowtell, Karen J. Mullinger,",
        title:
          "Exploring the origins of EEG motion artefacts during simultaneous fMRI acquisition: implications for motion artefact correction",
        details:
          "Neuroimage, Elsevier Publications, Volume 173, 2018, Pages 188-198. (IF-5.835. Q1, Scopus Indexed). ",
        doi: "https://doi.org/10.1016/j.neuroimage.2018.02.034",
      },
      {
        author:
          "Muhammad E. H. Chowdhury, Amith Khandakar, Belayat Hossain, Khawla Alzoubi,",
        title:
          "Effects of the phantom shape on characterizing the gradient artefact of the EEG data in simultaneous EEG-fMRI",
        details:
          "Applied Science, 2018, 8 (10), 1969. (IF- 2.474, Q1, Scopus Indexed).",
        doi: "https://doi.org/10.3390/app8101969",
      },
    ],
  },
];

export default listOfArticles;
